import { Button, ButtonRow, ChipGroup, Heading, Treegrid, TimeAgo, TreegridCell, TreegridRow, IconLink } from "cai-fusion";
import { useEffect, useState } from "react";

import env from "../../../../configs/envConfig";
import { useIntegration } from "../../contexts/IntegrationContext";
import { useTransientVisibility } from "../../../fusion/Contexts/VisualContext";

import { ReactComponent as IconActive } from "./icons/icon-active.svg"
import { ReactComponent as IconUntested } from "./icons/icon-untested.svg"
import { ReactComponent as IconError } from "./icons/icon-error.svg"

import { ReactComponent as IconDraft } from "../../../../images/icon-draft.svg"
import { ReactComponent as IconCheckmark } from "../../../../images/icon-checkmark.svg"
import { ReactComponent as IconTrash } from "../../../../images/icon-trash.svg"

import ModifyIntegrationDrawer from "./overlay/modifyIntegrationDrawer";
import DeleteIntegrationModal from "./overlay/deleteIntegrationModal";

const DataConnections = () => {

    const [selectedTag, setSelectedTab] = useState("All");
    const [searchText, setSearchText] = useState("");
    const { types, integrations, setIsEditing, newIntegration } = useIntegration();
    const { show } = useTransientVisibility();

    const [filteredIntegrations, setFilteredIntegrations] = useState([...integrations])

    useEffect(() => {
        let newList = [...integrations]

        if (selectedTag !== "All") {
            let filterType = types.find((type) => type.name === selectedTag)
            if (filterType) {
                newList = newList.filter((integration) => integration.integrationType === filterType.id)
            }
        }

        if (searchText !== "") {
            newList = newList.filter((integration) => 
                integration.name.toLowerCase().includes(searchText.toLowerCase()) ||
                integration.description.toLowerCase().includes(searchText.toLowerCase())
            )
        }

        setFilteredIntegrations(newList)
    }, [selectedTag, searchText, integrations])

    const beginNewIntegration = async () => {
        await newIntegration();
        show('ModifyIntegrationDrawer')
    }

    return (
        <>
            <div className="row l-mt-sm">
                <div className="col-12">
                    <div className="l-row l-row--justify-between l-row--align-center">
                        <div className="col-md-9">
                            <Heading size={3}>Integrations</Heading>
                            <p className="a-muted-text">Manage connections to external data sources and integrations for {env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"}. Configure API connections, data sync settings, and authentication credentials for third-party systems.</p>
                        </div>
                        <div className="col-md-3">
                            <ButtonRow>
                                <Button
                                    children="Add Integration"
                                    onClick={beginNewIntegration}
                                />
                            </ButtonRow>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="a-search-input l-mt-sm">
                                <label htmlFor="connection-search-input" className="visually-hidden">Search integrations</label>
                                <input type="search" 
                                    className="a-search-input__text-box" 
                                    id="connection-search-input"
                                    placeholder="Search integrations..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </div>
                            <ChipGroup 
                                className="l-mt-xs"
                                isSelectable
                                selected={selectedTag}
                                chipTexts={["All", "SQL Server", "REST API"]}
                                onClose={(chipText) => setSelectedTab(chipText)}
                            />
                            <div className="o-block l-mt-sm">
                                {filteredIntegrations.length === 0
                                ?   <div className="text-center l-mt-xs" aria-colspan={4}>
                                        <p className="a-muted-text">There are no integrations that match that criteria.</p>   
                                    </div>
                                :   <Treegrid 
                                        isCompact 
                                        columnSizes={["xx-wide", "medium", "small"]} // "small"
                                        headings={["Name", "Type", ""]} // "Status",
                                    >
                                        {filteredIntegrations.map((integration) => 
                                            <IntegrationDisplayItem integrationObj={integration} key={integration?.id} />    
                                        )}
                                    </Treegrid>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModifyIntegrationDrawer />
            <DeleteIntegrationModal />
        </>
    )
}


const IntegrationDisplayItem = ({integrationObj}) => {

    const { show } = useTransientVisibility();
    const { types, setIsEditing, editIntegration, setCurrIntegration } = useIntegration();

    const iconList = {
        "Active": IconActive,
        "Untested": IconUntested,
        "Error": IconError
    }

    const beginEditIntegration = async () => {
        await editIntegration(integrationObj);
        show('ModifyIntegrationDrawer')
    }

    let filterType = types.find((type) => type.id === integrationObj?.integrationType);

    return (
        <TreegridRow>
            <TreegridCell> { /* Basic Information */ }
                <p className="a-subtle-text l-mb-none"><strong>{integrationObj?.name}</strong></p>
                <p className="a-subtle-text a-muted-text l-mt-none l-mb-none">{integrationObj?.description}</p>
                <p className="a-subtle-text a-muted-text l-mt-none">Last tested {<TimeAgo timestamp={integrationObj?.updatedAt} />}</p>
            </TreegridCell>
            <TreegridCell> { /* Type */ }
                <span className="a-subtle-text">{filterType?.name}</span>
            </TreegridCell>
            {/* <TreegridCell>
                <Tag 
                    isImportant={integrationObj?.status === "Error"}
                    Icon={iconList[integrationObj?.status]}
                >
                    {integrationObj?.status}
                </Tag>
            </TreegridCell> */}
            <TreegridCell alignment="right"> { /* Actions */ }
                <IconLink 
                    Icon={IconDraft} 
                    onClick={beginEditIntegration}
                />
                {/* <IconLink Icon={IconCheckmark} /> */}
                <IconLink 
                    isDescrutive 
                    Icon={IconTrash}
                    onClick={() => {
                        setCurrIntegration({...integrationObj});
                        show('DeleteIntegrationModal')
                    }}
                />
            </TreegridCell>
        </TreegridRow>
    );
}

export default DataConnections;